const styles = (theme) => ({
  header: {
    padding: '20px 15px',
    backgroundColor: theme.palette.common.white,
    position: 'fixed',
    top: 0,
    zIndex: 9,
    width: '100%',
  },
  container: {
    maxWidth: 1200,
    margin: 'auto',
    paddingInline: 24,
    alignItems: 'center',
  },
  logoWrapper: {
    marginBottom: 0,
  },
  logo: {
    display: 'inline-block',
    cursor: 'pointer',
  },
  list: {
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'baseline',
    padding: 0,
  },
  navigationItem: {
    width: 'auto',
    padding: '8px 10px',
  },
  itemLink: {
    color: theme.palette.common.grey300,
    fontSize: theme.typography.fontSize13,
    lineHeight: '1.5',
    cursor: 'pointer',
    textDecoration: 'none',
    '&.active': {
      color: theme.palette.common.blue400,
      fontWeight: theme.typography.fontWeightSemiBold,
    },
  },
  lang: {
    marginInlineStart: 20,
  },
});

export default styles;
